// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"sidebar-buttons_button_wrapper__lz8F2","text_button_wrapper":"sidebar-buttons_text_button_wrapper__wmDNr"};